<template>
  <!--新增团员/详情-->
  <div>
    <a-modal
      title="新增团员"
      style="top: 20px"
      :width="1200"
      v-model="visible"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
      :footer="false"
      :maskClosable="false"
    >
      <a-tabs :activeKey="activeKey" @change="callback1">
        <a-tab-pane tab="团员详情" key="1">
          <div class="table-page-search-wrapper">
            <a-form :form="form" layout="inline" style="margin-left: 30px" @submit="handleSubmit">
              <a-row :gutter="24">
                <a-col :md="4" :sm="24">
                  <span
                    style="
                      color: deepskyblue;
                      font-size: 20px;
                      margin-left: -20px;
                      margin-bottom: 20px;
                      display: inline-block;
                    "
                    >团员基本信息</span
                  >
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-button type="primary" @click="resetPwd(recordPwd)">重置密码</a-button>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item label="姓名" style="width: 232px; margin-left: 28px">
                    <a-input
                      :disabled="memberShow"
                      v-decorator="['ToNames', { rules: [{ required: true, message: '请输入姓名' }] }]"
                      autocomplete="off"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="联系方式" style="width: 260px">
                    <a-input
                      :disabled="memberShow"
                      v-decorator="['phone', { rules: [{ validator: this.isPhone, required: true }] }]"
                      autocomplete="off"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="用户名" style="width: 246px; margin-left: 14px">
                    <a-input
                      :disabled="code != 2 || memberShow"
                      v-decorator="[
                        'ToLogin',
                        { rules: [{ min: 5, max: 20, required: true, message: '请输入5-20位字符!' }] },
                      ]"
                      autocomplete="off"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="6" v-if="!revisability">
                  <a-form-item label="密码" style="width: 260px">
                    <input type="password" style="display: none" />
                    <a-input
                      :disabled="revisability"
                      :type="textType"
                      onfocus="this.type='password'"
                      autocomplete="off"
                      v-decorator="['Toword', { rules: [{ validator: this.isPwd, required: true }] }]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="性别" style="width: 232px; margin-left: 28px">
                    <a-select
                      :disabled="memberShow"
                      v-decorator="['sex', { rules: [{ required: true, message: '请选择性别' }], initialValue: '0' }]"
                    >
                      <a-select-option value="0"> 男 </a-select-option>
                      <a-select-option value="1"> 女 </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="派单置顶" style="width: 260px">
                    <a-select
                      :disabled="memberShow"
                      v-decorator="[
                        'isTop',
                        { rules: [{ required: true, message: '请选择是否置顶' }], initialValue: '1' },
                      ]"
                    >
                      <a-select-option value="0"> 是 </a-select-option>
                      <a-select-option value="1"> 否 </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="接单方式">
                    <a-select
                      :disabled="memberShow"
                      mode="multiple"
                      @change="handleChange9"
                      v-decorator="[
                        'receiveOrderList',
                        { rules: [{ required: true, message: '请选择接单方式' }], initialValue: '1' },
                      ]"
                    >
                      <a-select-option value="0"> 自动接单 </a-select-option>
                      <a-select-option value="1"> 手动接单 </a-select-option>
                      <a-select-option value="2"> 抢单 </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <!-- <a-col :span="2">
                  <a-button
                    v-show="show"
                    :disabled="memberShow2 && !memberListDetail"
                    style="margin-top: 10px;margin-left:-20px;width: 80px "
                    type="primary"
                    @click="Tomap()"
                    >电子围栏1</a-button
                  >
                </a-col> -->
              </a-row>
              <a-row :gutter="24">
                <a-col :span="18">
                  <a-row>
                    <a-col :span="7">
                      <a-form-item label="注册地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select
                          :disabled="memberShow"
                          v-decorator="['province', { rules: [{ required: true, message: '请选择省' }] }]"
                          @change="haveProvince3"
                        >
                          <a-select-option v-for="type in data1" :key="type.provinceCode">{{
                            type.provinceName
                          }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="5">
                      <a-form-item>
                        <a-select
                          :disabled="memberShow"
                          v-decorator="['city', { rules: [{ required: true, message: '请选择市' }] }]"
                          @change="haveProvince4"
                        >
                          <a-select-option v-for="type in data3" :key="type.cityCode">{{
                            type.cityName
                          }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="5">
                      <a-form-item>
                        <a-select
                          :disabled="memberShow"
                          v-decorator="['area', { rules: [{ required: true, message: '请选择区' }] }]"
                        >
                          <a-select-option v-for="type in data5" :key="type.areaCode">{{
                            type.areaName
                          }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="7">
                      <a-form-item>
                        <a-input
                          autocomplete="off"
                          :disabled="memberShow"
                          v-decorator="['detailedAddress', { rules: [{ required: true, message: '请输入详情地址' }] }]"
                          style="width: 220px"
                        />
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-col>
                <a-col :span="6" style="margin-top: 10px">
                  <a-form-item label="当日最大接单量" style="width: 260px">
                    <a-input-number id="inputNumber" v-decorator="['maxReceiveOrder']" :min="0" />
                  </a-form-item>
                </a-col>
              </a-row>
              <div style="margin-bottom: 20px">
                <a-row :gutter="24">
                  <a-col :md="24" :sm="24">
                    <!--<a-form-item label="服务类别" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
                    <!--<a-checkbox-group-->
                    <!--:disabled="memberShow"-->
                    <!--v-decorator="['installType.installType',{ initialValue: addd , rules:[{required: true, message: '请选择服务类别'}]}]"-->
                    <!--style="width: 100%;margin-top:5px;"-->
                    <!--@change="handleCheck11"-->
                    <!--&gt;-->
                    <!--<a-checkbox v-for="type in restaurantTypes1"  :value="type.code">-->
                    <!--{{type.label}}-->
                    <!--</a-checkbox>-->
                    <!--</a-checkbox-group>-->
                    <!--</a-form-item>-->
                    <a-form-item label="服务类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-checkbox-group
                        v-decorator="[
                          'installType.installType',
                          { rules: [{ required: true, message: '请选择服务类别' }], initialValue: addd },
                        ]"
                        style="width: 100%; margin-top: 5px"
                        @change="handleCheck11"
                      >
                        <a-checkbox v-for="type in restaurantTypes1" :value="type.code">
                          {{ type.label }}
                        </a-checkbox>
                      </a-checkbox-group>
                    </a-form-item>
                  </a-col>
                  <a-col :md="24" :sm="24">
                    <a-form-item>
                      <a-tabs ref="tabPane" @change="callback2" type="card">
                        <a-tab-pane v-for="type in installTabs" :tab="type.label" :key="type.code">
                          <a-form-item label="标签" :labelCol="labelCol" :wrapperCol="wrapperCol" class="redItem">
                            <a-checkbox-group
                              v-decorator="[
                                'masterLabelList' + '$' + type.code,
                                { initialValue: getInitalValue(type.code) },
                              ]"
                              style="width: 100%; margin-top: 5px"
                              @change="handleCheck2"
                              :key="'masterLabelList' + '$' + type.code"
                            >
                              <a-checkbox
                                @change="tabChecked"
                                v-for="item in data4[type.code]"
                                :value="item.installLabelId"
                                :key="type.code + item.installLabelId"
                              >
                                {{ item.installLabelName }}
                              </a-checkbox>
                            </a-checkbox-group>
                          </a-form-item>
                        </a-tab-pane>
                      </a-tabs>
                    </a-form-item>
                    <!--<a-form-item>-->
                    <!--<a-tabs @change="callback2" type="card">-->
                    <!--<a-tab-pane v-for="type in installTabs" :tab="type.label" :key="type.code">-->
                    <!--<a-form-item label="标签" :labelCol="labelCol" :wrapperCol="wrapperCol" class="redItem">-->
                    <!--<a-checkbox-group-->
                    <!--v-decorator="['masterLabelList' + '$' + type.code, { initialValue: getInitalValue(type.code) }]"-->
                    <!--style="width: 100%;margin-top:5px;"-->
                    <!--@change="handleCheck2"-->
                    <!--:disabled="memberShow"-->
                    <!--&gt;-->
                    <!--<a-checkbox v-for="item in data4[type.code]" :value="item.installLabelId" :key="type.code + item.installLabelId">-->
                    <!--{{item.installLabelName}}-->
                    <!--</a-checkbox>-->
                    <!--</a-checkbox-group>-->
                    <!--</a-form-item>-->
                    <!--</a-tab-pane>-->
                    <!--</a-tabs>-->
                    <!--</a-form-item>-->
                  </a-col>
                </a-row>
                <a-row v-if="showAction" :gutter="24" style="margin-top: 80px">
                  <a-col :md="12" :sm="24">
                    <div style="min-height: 400px; position: relative">
                      <!--雷达图-->
                      <div style="width: 500px; height: 500px" ref="chart"></div>
                      <div id="alerts">
                        <a-card :bordered="true" style="width: 190px">
                          <p>虚拟得分1:{{ ScoreArr.firstFicScore }}</p>
                          <p>虚拟得分2:{{ ScoreArr.secondFicScore }}</p>
                          <p>虚拟得分透明度1:{{ ScoreArr.firstFicTransparency }}</p>
                          <p>虚拟得分透明度2:{{ ScoreArr.secondFicTransparency }}</p>
                        </a-card>
                      </div>
                    </div>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <div style="min-height: 400px">
                      <a-form-item label="得分" :labelCol="labelCol" :wrapperCol="wrapperCol" style="width: 260px">
                        <a-input :disabled="true" v-model="queryParam.abilityScore" />
                      </a-form-item>
                      <a-table :columns="columns" :pagination="pagination" :data-source="tabeldata" bordered>
                        <template slot="title" slot-scope="currentPageData"> 接单情况 </template>
                      </a-table>
                    </div>
                  </a-col>
                </a-row>
                <a-row v-if="showAction" :gutter="24">
                  <a-col :md="6" :sm="24">
                    <span style="color: deepskyblue; font-size: 20px; margin-left: -20px; display: inline-block"
                      >团员钱包</span
                    >
                  </a-col>
                </a-row>
                <a-row v-if="showAction" :gutter="24" style="margin-top: 80px">
                  <a-col :md="6" :sm="24">
                    <div>
                      <a-table :columns="columns2" :pagination="pagination2" :data-source="tabeldata2" bordered>
                      </a-table>
                    </div>
                  </a-col>
                </a-row>
                <div style="margin: 50px 0 20px 0">
                  <span style="color: deepskyblue; font-size: 20px">团员档案</span>
                </div>
                <a-row :gutter="24">
                  <a-col :span="6">
                    <a-form-item label="师傅等级" style="width: 260px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select :disabled="memberShow" v-decorator="['masterLevel']">
                        <a-select-option v-for="type in restaurantTypes2" :key="type.code">{{
                          type.label
                        }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="6">
                    <a-form-item
                      style="width: 246px; margin-left: 14px"
                      label="结算方式"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                    >
                      <a-select :disabled="memberShow" v-decorator="['settleType']">
                        <a-select-option v-for="type in restaurantTypes3" :key="type.code">{{
                          type.label
                        }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="6">
                    <a-form-item style="width: 260px" label="结算周期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select :disabled="memberShow" v-decorator="['settleTime']">
                        <a-select-option v-for="type in restaurantTypes4" :key="type.code">{{
                          type.label
                        }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="6">
                    <a-form-item style="width: 260px" label="户名" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input autocomplete="off" :disabled="memberShow" v-decorator="['bankUserName']" />
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :gutter="24">
                  <a-col :md="6" :sm="24">
                    <a-form-item
                      label="开户行"
                      style="width: 246px; margin-left: 14px"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                    >
                      <!--<a-input autocomplete="off" :disabled="memberShow" v-decorator="['bankName']"  />-->
                      <a-select
                        showSearch
                        optionFilterProp="children"
                        v-decorator="['bankName']"
                        :filterOption="filterOption"
                        allowClear="true"
                      >
                        <a-select-option v-for="item of bankName1" :title="item.name" :key="item.id">{{
                          item.name
                        }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="银行卡账号" style="width: 260px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input
                        autocomplete="off"
                        :disabled="memberShow"
                        v-decorator="['bankNum', { rules: [{ validator: this.bankNum, required: false }] }]"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :md="12" :sm="24">
                    <a-form-item label="团员备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input
                        autocomplete="off"
                        :disabled="memberShow"
                        v-decorator="['remark']"
                        style="width: 470px"
                      />
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :gutter="24" style="height: 80px">
                  <a-col :md="6" :sm="24">
                    <a-form-item label="身份证号" style="width: 260px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input
                        autocomplete="off"
                        :disabled="memberShow"
                        v-decorator="['idCard', { rules: [{ validator: this.idCards, required: false }] }]"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="证件有效期" style="width: 260px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-range-picker
                        :disabled="memberShow"
                        v-decorator="['StartTime']"
                        :showTime="{ format: 'HH:mm:ss' }"
                        format="YYYY-MM-DD"
                        :placeholder="['开始时间', '结束时间']"
                        @change="onChange1"
                        @ok="onOk"
                        style="width: 100%"
                      />
                    </a-form-item>
                  </a-col>

                  <a-col v-if="showAction" :md="8" :sm="24">
                    <a-form-item label="总接单情况" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <!--<a-input v-decorator="['privateMaster']"  style="width: 230px;"/>-->
                      <a-table bordered :dataSource="setData" :columns="columns1" :pagination="false" size="small">
                      </a-table>
                    </a-form-item>
                  </a-col>
                </a-row>
                <!--上传身份证图片-->
                <a-row :gutter="24" style="padding: 10px 0">
                  <a-col :md="8" :sm="24">
                    <a-form-item label="身份证正面" :labelCol="{ labelCol: { span: 9 }, wrapperCol: { span: 15 } }">
                      <a-upload
                        :action="uploadUrlb"
                        listType="picture-card"
                        :fileList="fileList1"
                        :headers="headers"
                        @preview="handPreview1"
                        @change="handChange1"
                        :beforeUpload="beforeUpload1"
                        :disabled="memberShow"
                      >
                        <div v-if="fileList1.length < 1">
                          <a-icon type="plus" />
                          <div class="ant-upload-text">身份证正面</div>
                        </div>
                      </a-upload>
                      <a-modal :visible="previewVisible1" :footer="null" @cancel="handCancel1">
                        <img alt="example" style="width: 100%" :src="coverUrl1" />
                      </a-modal>
                    </a-form-item>
                  </a-col>
                  <a-col :md="8" :sm="24">
                    <a-form-item label="身份证背面" :labelCol="{ labelCol: { span: 9 }, wrapperCol: { span: 15 } }">
                      <div class="clearfix">
                        <a-upload
                          :action="uploadUrlb"
                          listType="picture-card"
                          :fileList="fileList2"
                          :headers="headers"
                          @preview="handPreview2"
                          @change="handChange2"
                          :beforeUpload="beforeUpload1"
                          :disabled="memberShow"
                        >
                          <div v-if="fileList2.length < 1">
                            <a-icon type="plus" />
                            <div class="ant-upload-text">身份证反面</div>
                          </div>
                        </a-upload>
                        <a-modal :visible="previewVisible2" :footer="null" @cancel="handCancel2">
                          <img alt="example" style="width: 100%" :src="coverUrl2" />
                        </a-modal>
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="8" :sm="24">
                    <a-form-item label="免冠照片" :labelCol="{ labelCol: { span: 9 }, wrapperCol: { span: 24 } }">
                      <div class="clearfix">
                        <a-upload
                          :action="uploadUrlb"
                          listType="picture-card"
                          :fileList="fileList3"
                          :headers="headers"
                          @preview="handPreview3"
                          @change="handChange3"
                          :disabled="memberShow"
                          :beforeUpload="beforeUpload1"
                        >
                          <div v-if="fileList3.length < 1">
                            <a-icon type="plus" />
                            <div class="ant-upload-text">免冠照</div>
                          </div>
                        </a-upload>
                        <a-modal :visible="previewVisible3" :footer="null" @cancel="handCancel3">
                          <img alt="example" style="width: 100%" :src="coverUrl3" />
                        </a-modal>
                      </div>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :gutter="24" style="margin-top: 70px">
                  <a-col v-if="showAction" :span="6" style="padding: 10px 0">
                    合同文件
                    <a-upload
                      :fileList="fileList5"
                      name="file"
                      :multiple="true"
                      :action="uploadUrlb2"
                      :headers="headers"
                      :beforeUpload="beforeUpload"
                      @change="uploadChange"
                      showUploadList="false"
                    >
                      <a-button class="twobtn" style="margin-left: 10px" type="primary">上传</a-button>
                    </a-upload>
                  </a-col>
                  <a-col v-if="showAction" :md="24" :sm="24" style="margin-bottom: 20px">
                    <a-table :dataSource="contractData" :columns="columns3" :pagination="false" size="small">
                      <a slot="action3" slot-scope="text, record">
                        <a-checkbox v-model="record.isMainContract == 0" @change="checkChange(record)">
                          主合同
                        </a-checkbox>
                      </a>
                      <template slot="name" slot-scope="text, record">
                        <editable-cell :text="text" @change="onCellChange(record, 'name', $event)" />
                      </template>
                      <template slot="name2" slot-scope="text, record">
                        <editable-cell2
                          :start="record.contractStartTime"
                          :end="record.contractEndTime"
                          @change="onCellChange2(record, 'name', $event)"
                        />
                      </template>
                      <template slot="name3" slot-scope="text, record">
                        <editable-cell3 :text="text" @change="onCellChange3(record, 'name', $event)" />
                      </template>
                      <span slot="action2" slot-scope="text, record">
                        <!--<a  @click="delsee(record)">上传</a>-->
                        <!--<a-divider type="vertical"/>-->
                        <a @click="delsee2(record.contractPdfAddress)">查看</a>
                        <a-divider type="vertical" />
                        <a @click="delByIds(record)">下载</a>
                        <a-divider type="vertical" />
                        <a v-if="record.disable == 1" @click="showState(record)">启用</a>
                        <a v-else @click="showState(record)">禁用</a>
                        <a-divider type="vertical" />
                        <a v-if="deleteEnable" @click="delaction(record)">删除</a>
                      </span>
                    </a-table>
                  </a-col>
                  <a-col :md="24" :sm="24" style="margin-bottom: 50px">
                    <a-form-item label="备注">
                      <a-textarea autocomplete="off" :disabled="memberShow" :rows="3" v-decorator="['bigRemark']" />
                    </a-form-item>
                  </a-col>
                </a-row>

                <a-affix style="position: fixed; bottom: 52px; left: 40%; z-index: 10">
                  <div style="width: 200px">
                    <a-button :disabled="memberShow" style="float: left" type="primary" html-type="submit"
                      >提交</a-button
                    >
                    <a-button style="float: right" @click="getClose">取消</a-button>
                  </div>
                </a-affix>
              </div>
            </a-form>
          </div>
          <tomap ref="modal2" @ok="handleOk"></tomap>
          <p-d-fmodel ref="modal3"></p-d-fmodel>
        </a-tab-pane>
        <a-tab-pane tab="团员金额" key="2" v-if="showAction">
          <a-tabs @change="callback3" type="card">
            <a-tab-pane
              v-for="items in money"
              :tab="items.installName"
              :key="items.installType"
              :class="[memberShow ? 'disEvents' : '']"
            >
              <a-form :form="form3" layout="inline" style="margin-left: 30px">
                <a-row :gutter="8" v-for="item in items.memberPriceList" :key="item.memberPriceId">
                  <a-col :span="6" :offset="3">
                    <a-form-item :label="item.priceName" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                      <a-input v-model="item.price" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item label="备注" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                      <a-input v-model="item.priceRemark" style="width: 300px" />
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-form>
            </a-tab-pane>
          </a-tabs>
          <a-affix :offsetBottom="80">
            <a-button
              style="margin-right: 100px; width: 150px"
              type="primary"
              :disabled="memberShow"
              @click="handleSubmit1"
              >提交</a-button
            >
            <a-button style="width: 150px; margin-left: 120px" @click="getClose">取消</a-button>
          </a-affix>
          <!--<div style="margin-left:35%;margin-top: 20px;width: 500px" >-->
          <!--<a-button  style="margin-right: 100px;width:150px;" :disabled="memberShow" type="primary" @click="handleSubmit1">提交</a-button>-->
          <!--<a-button style="width:150px" @click="getClose">取消</a-button>-->
          <!--</div>-->
        </a-tab-pane>
      </a-tabs>
    </a-modal>
    <user-pwd-modal ref="pwdmodal"></user-pwd-modal>
  </div>
</template>

<script>
import { STable } from '@/components'
import { Radar } from '@/components'
import Tomap from './Tomap2.vue'
import pick from 'lodash.pick'
import {
  selectALLInstallLabel,
  queryUserArea,
  deleteUserArea,
  getelectCityName,
  getSelectAllProvince,
  getelectAreaName,
  addUserArea,
  selectInstallTypeAndLabel,
} from '@/api/master/MasterList'
import {
  infoInsert,
  masterof,
  foInsert,
  deleteContract,
  openContract,
  disableContract,
  infoContract,
  infoupdateCont,
  updateMain2,
  PointgetMember,
  memberPriceUpdate,
  memberPriceList,
  infoSelectOrder,
} from '@/api/master/TeamManagement'
import { getDictMap } from '../../../utils/dict'
import { selectFindAll } from '@/api/enterprise/enterprise'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import PDFmodel from './PDFmodel.vue'
import UserPwdModal from '@/views/system/modules/UserPwdModal'
import { checkPermission } from '@/utils/permissions'
import _ from 'lodash'
const EditableCell = {
  template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input :value="value" @change="handleChange" @pressEnter="check" style="width: 210px" /><a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
          />
        </div>
        <div v-else class="editable-cell-text-wrapper">
          {{ value || ' ' }}
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
    `,
  props: {
    text: String,
  },
  data() {
    return {
      value: this.text,
      editable: false,
    }
  },
  methods: {
    handleChange(e) {
      console.log('handleChange')
      const value = e.target.value
      this.value = value
    },
    check() {
      console.log('check')
      this.editable = false
      this.$emit('change', this.value)
    },
    edit() {
      console.log('edit')
      this.editable = true
    },
  },
}

const EditableCell3 = {
  template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input :value="value" @change="handleChange" @pressEnter="check" style="width: 210px" /><a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
          />
        </div>
        <div v-else class="editable-cell-text-wrapper">
          {{ value || ' ' }}
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
    `,
  props: {
    text: String,
  },
  data() {
    return {
      value: this.text,
      editable: false,
    }
  },
  methods: {
    handleChange(e) {
      console.log('handleChange')
      const value = e.target.value
      this.value = value
    },
    check() {
      console.log('check')
      this.editable = false
      this.$emit('change', this.value)
    },
    edit() {
      console.log('edit')
      this.editable = true
    },
  },
}

const EditableCell2 = {
  template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
        <a-range-picker
            class="editable-cell-icon-check"
            style="width:210px"
            v-model="dataTime"
            @change="ChangeTime"
              :ranges="{ Today: [moment(), moment()], 'This Month': [moment(), moment().endOf('month')] }"
            />
        <a-input  @pressEnter="check" style="width: 210px;display: none" /><a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
            style="width:210px"
          />

        </div>
        <div v-else class="editable-cell-text-wrapper">
            <span v-if="start === null||end === null"></span>
            <span v-else>{{ start + ' - ' + end || ' ' }}</span>
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
    `,
  props: {
    start: String,
    end: String,
  },
  data() {
    return {
      value: this.text,
      editable: false,
      dataTime: '',
      // show:true,
    }
  },
  methods: {
    //
    ChangeTime(dates, dateStrings) {
      this.start = dateStrings[0]
      this.end = dateStrings[1]
      if (this.start != '' && this.end != '') {
        this.value = [dateStrings[0], dateStrings[1]]
        this.dataTime = [moment(dateStrings[0]), moment(dateStrings[1])]
      }
    },
    handleChange(e) {
      const value = e.target.value
      this.value = value
    },
    check() {
      //结束编辑
      console.log('check')
      this.editable = false
      this.$emit('change', this.value)
    },
    edit() {
      //开始编辑
      console.log('edit')
      this.editable = true
    },
  },
}

export default {
  name: 'TeamDetails',
  components: {
    STable,
    Radar,
    Tomap,
    EditableCell,
    EditableCell2,
    EditableCell3,
    PDFmodel,
    UserPwdModal,
  },
  data() {
    return {
      bankName1: [
        { id: '中国工商银行', name: '中国工商银行' },
        { id: '中国银行', name: '中国银行' },
        { id: '中国建设银行', name: '中国建设银行' },
        { id: '中国农业银行', name: '中国农业银行' },
        { id: '交通银行', name: '交通银行' },
        { id: '中国邮政储蓄银行', name: '中国邮政储蓄银行' },
        { id: '招商银行', name: '招商银行' },
        { id: '上海浦东发展银行', name: '上海浦东发展银行' },
        { id: '民生银行', name: '民生银行' },
        { id: '兴业银行', name: '兴业银行' },
        { id: '中信银行', name: '中信银行' },
        { id: '平安银行', name: '平安银行' },
        { id: '光大银行', name: '光大银行' },
        { id: '华夏银行', name: '华夏银行' },
        { id: '广发银行', name: '广发银行' },
        { id: '上海银行', name: '上海银行' },
        { id: '南京银行', name: '南京银行' },
        { id: '渤海银行', name: '渤海银行' },
        { id: '江苏银行', name: '江苏银行' },
        { id: '恒丰银行', name: '恒丰银行' },
        { id: '徽商银行', name: '徽商银行' },
        { id: '国家开发银行', name: '国家开发银行' },
        { id: '上海农村商业银行', name: '上海农村商业银行' },
        { id: '农村信用社', name: '农村信用社' },
        { id: '农村合作银行', name: '农村合作银行' },
      ],
      textType: '',
      revisability: false,
      deleteEnable: checkPermission('master:teamList:contract:delete'),
      addEnable: checkPermission('master:teamList:memberList:add'),
      memberListDetail: checkPermission('master:teamList:memberList:detail'),
      form3: this.$form.createForm(this),
      activeKey: '1',
      money: [],
      memberShow2: '',
      memberShow: '',
      EchartsData: '',
      ScoreArr: '',
      //上传身份证
      previewVisible1: false,
      previewVisible2: false,
      previewVisible3: false,
      uploadUrlb: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=master',
      uploadUrlb2: '',
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList5: [],
      coverUrl1: '',
      coverUrl2: '',
      coverUrl3: '',
      identity: [
        {
          identityType: '',
          identityUrl: '',
        },
        {
          identityType: '',
          identityUrl: '',
        },
        {
          identityType: '',
          identityUrl: '',
        },
      ],
      //上传身份证End
      previewImage: '',
      installType: [],
      setData: [],
      addd: [],
      columns1: [
        {
          title: '总结单量',
          dataIndex: 'receiveOrder',
          // scopedSlots: { customRender: 'receiveOrder'},
          align: 'center',
        },
        {
          title: '未销单',
          dataIndex: 'notSaleOrder',
          align: 'center',
        },
        {
          title: '总投诉率',
          dataIndex: 'complaintRateRecent',
          // scopedSlots: { customRender: 'complaint'},
          align: 'center',
        },
      ],
      restaurantTypes2: [],
      restaurantTypes3: [],
      restaurantTypes4: [],
      coverageData: [],
      contractData: [],
      columns3: [
        {
          title: '合同文件',
          dataIndex: 'disable',
          scopedSlots: { customRender: 'action2' },
        },
        {
          title: '合同编号',
          dataIndex: 'contractNo',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '合同名称',
          dataIndex: 'contractName',
          scopedSlots: { customRender: 'name3' },
        },
        {
          title: '合同有效期',
          dataIndex: 'contractDuration',
          scopedSlots: { customRender: 'name2' },
        },
        {
          title: '是否主合同',
          dataIndex: 'isMainContract',
          scopedSlots: { customRender: 'action3' },
        },
      ],
      columns4: [
        {
          title: '姓名',
          dataIndex: 'userName',
          align: 'center',
        },
        {
          title: '省',
          dataIndex: 'provinceName',
          align: 'center',
        },
        {
          title: '市',
          dataIndex: 'cityName',
          align: 'center',
        },
        {
          title: '区',
          dataIndex: 'areaName',
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ],
      loading: false,
      pagination: false,
      columns: [
        {
          title: '接单量',
          dataIndex: 'receiveOrder',
          align: 'center',
        },
        {
          title: '未销单',
          dataIndex: 'noOrder',
          align: 'center',
        },
        {
          title: '近30天投诉率',
          dataIndex: 'complaint',
          align: 'center',
        },
      ],
      tabeldata: [],
      pagination2: false,
      columns2: [
        {
          title: '已完成金额',
          dataIndex: 'Orderquantity',
          align: 'center',
        },
        {
          title: '待入账金额',
          dataIndex: 'Salesvolume',
          align: 'center',
        },
        {
          title: '可提现金额',
          dataIndex: 'Complaintrate',
          align: 'center',
        },
      ],
      tabeldata2: [],
      radarData: [],
      installTabs: [],
      show: false,
      data4: [],
      data1: [],
      data3: [],
      data5: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      visible: false,
      visible3: false,
      visible4: false,
      confirmLoading: false,
      record: '',
      queryParam: {},
      restaurantTypes1: [],
      id: '',
      form: this.$form.createForm(this),
      code: '',
      provinceCode: '',
      showAction: false,
      userId: '',
      startTime: '',
      endTime: '',
      isType2: '',
      recordPwd: '',
    }
  },
  async created() {
    // 省
    getSelectAllProvince().then((res) => {
      this.data1 = res.rows
    })
    selectFindAll({ dictTypes: 'tech_level,master_settle_method,settle_cycle,install_type' }).then((res) => {
      this.restaurantOperTypeMap2 = res.tech_level
      this.restaurantOperTypeMap2.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes2.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap3 = res.master_settle_method
      this.restaurantOperTypeMap3.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes3.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap4 = res.settle_cycle
      this.restaurantOperTypeMap4.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes4.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap1 = res.install_type
      this.restaurantOperTypeMap1.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes1.push({ code: value.dictValue, label: value.dictLabel })
      })
    })
    // 标签
    selectInstallTypeAndLabel().then((res) => {
      // console.log(res.data)
      this.data4 = res.data
    })
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 密码正则表达式
    isPwd(rule, value, callback) {
      const pwdRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,64}$/
      if (value && !pwdRegex.test(value)) {
        callback(new Error('请输入8位以上密码，必须包含数字、字母、英文特殊字符'))
      } else if (value == undefined || value.length == 0) {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    },
    // 重置密码
    resetPwd(record) {
      // console.log(record)
      this.$refs.pwdmodal.edit(record)
    },
    //查看
    delsee2(contractAddress) {
      this.$refs.modal3.delsee(
        process.env.VUE_APP_API_BASE_URL +
          '/dfs/download?fileName=' +
          contractAddress +
          '&token=' +
          Vue.ls.get(ACCESS_TOKEN)
      )
    },
    //下载
    delByIds(contract) {
      console.log(contract)
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href =
        process.env.VUE_APP_API_BASE_URL +
        '/dfs/download?fileName=' +
        contract.contractAddress +
        '&token=' +
        Vue.ls.get(ACCESS_TOKEN)
      link.setAttribute('download', '导入学生账号模板')
      document.body.appendChild(link)
      link.click()
      // window.open(process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + contractAddress + '&token=' + Vue.ls.get(ACCESS_TOKEN))
    },
    onChange1(value, dateString) {
      this.startTime = dateString[0]
      this.endTime = dateString[1]
    },
    //银行卡号正则表达式
    bankNum(rule, value, callback) {
      const pwdRegex = /^[1-9]\d{16,19}$/
      console.log(value)
      if (value == undefined || value.length == 0) {
        callback()
      } else if (!pwdRegex.test(value)) {
        callback(new Error('请输入正确的银行卡号'))
      }
      callback()
    },
    //身份证正则表达式
    idCards(rule, value, callback) {
      const pwdRegex = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/

      if (value == undefined || value.length == 0) {
        callback()
      } else if (!pwdRegex.test(value)) {
        callback(new Error('请输入正确的身份证格式'))
      } else {
        console.log('jinru')
        callback()
      }
    },
    //手机号正则表达式
    isPhone(rule, value, callback) {
      const pwdRegex = /^((0\d{2,3}(-)?\d{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/
      if (value == undefined || value.length == 0) {
        callback(new Error('请输入联系方式'))
      } else if (!pwdRegex.test(value)) {
        callback(new Error('请输入正确的联系方式'))
      } else {
        callback()
      }
    },
    // tab页选择
    callback1(key) {
      this.activeKey = key
      if (key == 2) {
        memberPriceList({ memberId: this.id }).then((res) => {
          console.log('金额信息', res.rows)
          this.money = res.rows
        })
      }
    },
    // 修改团员金额提交
    handleSubmit1() {
      console.log(this.money)
      let result = []
      for (var item of this.money) {
        result = result.concat(item.memberPriceList)
      }
      memberPriceUpdate({ memberPriceList: result })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('修改成功')
            this.visible = false
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    beforeUpload1(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('上传文件格式不支持!')
        this.isType2 = 1
        return false
      } else {
        this.isType2 = 0
      }
    },
    //文件合同上传
    uploadChange(info) {
      this.fileList5 = info.fileList
      let that = this
      if (info.file.status !== 'uploading') {
      }
      if (info.file.status === 'done') {
        that.fileList5 = []
        that.$message.success(`上传成功`)
        that.ContractData()
      } else if (info.file.status === 'error') {
        this.$message.error(`上传失败`)
        that.fileList5 = []
      }
    },
    // 上传1
    handChange1({ fileList }) {
      if (this.isType2 == 0) {
        this.fileList1 = fileList
        if (fileList.length == 0) {
          this.identity[0].identityType = ''
          this.identity[0].identityUrl = ''
        } else {
          this.coverUrl1 = fileList[0].response.url
          this.identity[0].identityType = 0
          this.identity[0].identityUrl = this.coverUrl1
        }
      }
    },
    handPreview1(file) {
      if (file.response) {
        this.coverUrl1 =
          process.env.VUE_APP_API_BASE_URL +
          '/dfs/download?fileName=' +
          file.response.url +
          '&token=' +
          Vue.ls.get(ACCESS_TOKEN)
      } else {
        this.coverUrl1 =
          process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      }
      this.previewVisible1 = true
    },
    handCancel1() {
      this.previewVisible1 = false
    },
    // 上传2
    handChange2({ fileList }) {
      if (this.isType2 == 0) {
        this.fileList2 = fileList
        if (fileList.length == 0) {
          this.identity[1].identityType = ''
          this.identity[1].identityUrl = ''
        } else {
          this.coverUrl2 = fileList[0].response.url
          this.identity[1].identityType = 1
          this.identity[1].identityUrl = this.coverUrl2
        }
      }
    },
    handPreview2(file) {
      console.log(file, 'fileresponse')
      if (file.response) {
        this.coverUrl2 =
          process.env.VUE_APP_API_BASE_URL +
          '/dfs/download?fileName=' +
          file.response.url +
          '&token=' +
          Vue.ls.get(ACCESS_TOKEN)
      } else {
        this.coverUrl2 =
          process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      }
      this.previewVisible2 = true
    },
    handCancel2() {
      this.previewVisible2 = false
    },
    // 上传3
    handChange3({ fileList }) {
      if (this.isType2 == 0) {
        this.fileList3 = fileList
        if (fileList.length == 0) {
          this.identity[2].identityType = ''
          this.identity[2].identityUrl = ''
        } else {
          this.coverUrl3 = fileList[0].response.url
          this.identity[2].identityType = 2
          this.identity[2].identityUrl = this.coverUrl3
        }
      }
    },
    handPreview3(file) {
      if (file.response) {
        this.coverUrl3 =
          process.env.VUE_APP_API_BASE_URL +
          '/dfs/download?fileName=' +
          file.response.url +
          '&token=' +
          Vue.ls.get(ACCESS_TOKEN)
      } else {
        this.coverUrl3 =
          process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      }
      this.previewVisible3 = true
    },
    handCancel3() {
      this.previewVisible3 = false
    },
    beforeUpload(file) {
      let houzhui = file.name.split('.')
      const isJpgOrPng =
        houzhui[1] == 'doc' ||
        houzhui[1] == 'docx' ||
        houzhui[1] == 'xls' ||
        houzhui[1] == 'ppt' ||
        houzhui[1] == 'pptx' ||
        houzhui[1] == 'xlsx' ||
        houzhui[1] == 'pdf'
      if (!isJpgOrPng) {
        this.$message.error('上传文件格式不支持!')
        return false
      }
    },
    delaction(val) {
      //团员合同删除
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          deleteContract({
            memberContractId: val.contractId,
            //  memberId:that.id
          }).then((res) => {
            if (res.code === 0) {
              that.$message.success('删除成功')
              that.ContractData()
            } else {
              that.$message.error(res.msg)
            }
          })
        },
      })
    },
    onCellChange3(record, dataIndex, value) {
      //合同名称
      console.log(record, dataIndex, value)
      infoupdateCont({
        teamId: this.id,
        contractId: record.contractId,
        contractAddress: record.contractAddress,
        contractName: value,
        contractNo: record.contractNo,
        contractStartTime: record.contractStartTime,
        contractEndTime: record.contractEndTime,
      }).then((res) => {
        console.log(res)
        this.ContractData()
      })
    },
    onCellChange2(record, dataIndex, value) {
      //合同有效期
      infoupdateCont({
        teamId: this.id,
        contractId: record.contractId,
        contractAddress: record.contractAddress,
        contractName: record.contractName,
        contractNo: record.contractNo,
        contractStartTime: value[0],
        contractEndTime: value[1],
      }).then((res) => {
        this.ContractData()
      })
    },
    onCellChange(record, dataIndex, value) {
      //合同編號
      infoupdateCont({
        teamId: this.id,
        contractId: record.contractId,
        contractAddress: record.contractAddress,
        contractName: record.contractName,
        contractNo: value,
        contractStartTime: record.contractStartTime,
        contractEndTime: record.contractEndTime,
      }).then((res) => {
        this.ContractData()
      })
    },
    checkChange(value) {
      if (value.isMainContract == 0) {
        updateMain2({
          contractId: value.contractId,
          isMainContract: 1,
          teamId: this.id,
        }).then((res) => {
          if (res.code === 0) {
            this.$message.success('已取消主合同')
            this.ContractData()
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        updateMain2({
          contractId: value.contractId,
          isMainContract: 0,
          teamId: this.id,
        }).then((res) => {
          if (res.code === 0) {
            if (res.data == 9) {
              this.$message.success('只能设置一个主合同')
            } else {
              this.$message.success('已设为主合同')
            }
            this.ContractData()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    ContractData() {
      infoContract(this.id).then((res) => {
        this.contractData = res.rows
      })
    },
    showState(value) {
      console.log(value)
      let memberContractId = value.contractId
      let that = this
      if (value.disable == 1) {
        openContract({
          memberContractId: value.contractId,
        }).then((res) => {
          if (res.code === 0) {
            this.$message.success('启用成功')
            that.ContractData()
          } else {
            this.$message.error(res.msg)
          }
        })
      } else if (value.disable == 0) {
        disableContract({
          memberContractId: value.contractId,
        }).then((res) => {
          if (res.code === 0) {
            this.$message.success('禁用成功')
            that.ContractData()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    handleChange1({ fileList }) {
      this.fileList = fileList
    },
    haveProvince4(e) {
      //区
      this.data5 = []
      this.form.setFieldsValue({
        area: '',
      })
      getelectAreaName({ cityCode: e }).then((res) => {
        // console.log(res)
        this.data5 = res.rows
      })
    },
    haveProvince3(e) {
      //市
      this.data3 = []
      this.data5 = []
      this.form.setFieldsValue({
        city: '',
        area: '',
      })
      getelectCityName({ provinceCode: e }).then((res) => {
        this.data3 = res.rows
      })
    },
    getInitalValue(installType) {
      // this.tabeldata=[]
      for (var item of this.installType) {
        if (item.installType == installType) {
          return item.masterLabelList
        }
      }
      // infoSelectOrder({
      //   installType:installType,
      //   memberId:this.id
      // }).then(res=>{
      //   this.tabeldata.push(res.data)
      // })
    },
    getClose() {
      this.visible = false
    },
    handleOk() {
      this.$refs.table.refresh(true)
    },
    handleClose1() {
      this.visible3 = false
    },
    handleClose2() {
      this.visible4 = false
    },
    // 服务区域
    coverage() {
      this.visible3 = true
      queryUserArea({ userId: this.record.userId }).then((res) => {
        console.log(res.rows)
        this.coverageData = res.rows
      })
    },
    callback2(v) {
      this.tabeldata = []
      console.log(v)
      infoSelectOrder({
        installType: v,
        memberId: this.id,
      }).then((res) => {
        this.tabeldata.push(res.data)
      })
      this.$nextTick(() => {
        this.$refs['tabPane'].activeKey = v
      })
      for (let i = 0; i < this.installTabs.length; i++) {
        if (this.installTabs[i].code == v) {
          for (let k = 0; k < this.EchartsData.length; k++) {
            if (this.EchartsData[k].installType == this.installTabs[i].label) {
              this.initCharts(this.EchartsData[k])
            }
          }
        }
      }
      for (let m = 0; m < this.EchartsData.length; m++) {
        if (this.EchartsData[m].installType == v) {
          this.initCharts(this.EchartsData[m])
        }
      }
    },
    handleCheck12(values) {
      console.log(values)
    },
    Tomap() {
      PointgetMember(this.id).then((res) => {
        this.$refs.modal2.add(res.data, 1)
      })
    },
    handleChange9(value) {
      if (value.indexOf('0') == -1) {
        this.show = false
      } else {
        this.show = true
      }
    },
    //新增团员
    add(id, code) {
      this.Fileempty()
      this.code = code
      this.id = id
      this.visible = true
      this.installTabs = []
      this.ContractData()
      this.data3 = []
      this.data5 = []
      this.revisability = false
      if (code == 0) {
        //2为新增  1为编辑 0查看

        this.memberShow = true
      } else {
        this.memberShow = false
      }
      if (code == 1) {
        //2为新增  1为编辑 0查看
        this.memberShow2 = false
      } else {
        this.memberShow2 = true
      }
      if (code == 2) {
        //2为新增  1为编辑 0查看
        this.textType = 'text'
        this.showAction = false
      } else {
        this.textType = 'password'
        this.showAction = true
      }
      this.activeKey = '1'
      this.show = false
    },
    Fileempty() {
      this.fileList1 = []
      this.fileList2 = []
      this.fileList3 = []
      this.addd = []
      this.installType = []
      this.form.resetFields()
      this.activeKey = '1'
    },
    //用户名正则表达式
    // userText (rule, value, callback) {
    //   const pwdRegex =/^[a-zA-Z0-9_-]{5,20}$/
    //   if(value==undefined||value.length == 0){
    //     callback(new Error('请输入用户名'))
    //   }else if (!pwdRegex.test(value)) {
    //     callback(new Error('请输入5到20位(字母,数字,下划线,减号)'))
    //   }else{
    //     callback()
    //   }
    // },
    getImgToBase64(url, callback) {
      //将图片转换为Base64
      var canvas = document.createElement('canvas'),
        ctx = canvas.getContext('2d'),
        img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = function () {
        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(img, 0, 0)
        var dataURL = canvas.toDataURL('image/png')
        callback(dataURL)
        canvas = null
      }
      img.src = url
    },
    //查看编辑团员
    Edit(memberId, code, userId, record) {
      this.activeKey = '1'
      this.revisability = true
      if (code == 0) {
        //2为新增  1为编辑 0查看
        this.memberShow = true
      } else {
        this.memberShow = false
      }
      if (code == 1) {
        //2为新增  1为编辑 0查看
        this.memberShow2 = false
      } else {
        this.memberShow2 = true
      }
      if (code == 2) {
        //2为新增  1为编辑 0查看
        this.showAction = false
        this.textType = 'text'
      } else {
        this.textType = 'password'
        this.showAction = true
      }

      this.userId = userId
      this.Fileempty()
      this.showAction = true
      this.id = memberId //团员id
      this.uploadUrlb2 = process.env.VUE_APP_API_BASE_URL + '/dfs/uploadContract?type=MemberContract&id=' + this.id
      this.radarData = []
      this.code = code
      this.visible = true
      let that = this
      this.ContractData()

      this.setData = []
      // infoSelectOrder({
      //   installType:v,
      //   memberId:this.id
      // }).then(res=>{
      //   this.setData=res.data
      //   // console.log(res.data,'接单清空')
      // })
      masterof(memberId).then((res) => {
        this.recordPwd = res.data
        this.recordPwd.userId = this.userId
        for (var item of res.data.installType) {
          this.addd.push(item.installType)
        }
        that.installType = res.data.installType
        this.handleCheck11(this.addd)
        var listarr = []
        for (let k = 0; k < that.installType.length; k++) {
          for (let s = 0; s < that.installType[k].masterLabelList.length; s++) {
            listarr.push({
              code: k,
              installType: that.installType[k].masterLabelList[s].installLabel,
            })
          }
        }
        for (let p = 0; p < that.installType.length; p++) {
          that.installType[p].masterLabelList = []
          for (let v = 0; v < listarr.length; v++) {
            if (p == listarr[v].code) {
              that.installType[p].masterLabelList.push(listarr[v].installType)
            }
          }
        }
        res.data.installType = that.installType
        that.queryParam.province = res.data.province
        that.queryParam.city = res.data.city
        let Orderlist = []
        console.log(res.data.receiveOrderList, 'res.data.receiveOrderList')
        for (let i = 0; i < res.data.receiveOrderList.length; i++) {
          Orderlist.push(res.data.receiveOrderList[i].receiveType)
        }

        res.data.receiveOrderList = Orderlist
        //身份证回写

        for (let id of res.data.identityList) {
          if (id.identityType == '0') {
            this.getImgToBase64(
              process.env.VUE_APP_API_BASE_URL +
                '/dfs/download?fileName=' +
                id.identityUrl +
                '&token=' +
                Vue.ls.get(ACCESS_TOKEN),
              function (data) {
                that.fileList1.push({
                  uid: id.identityType,
                  name: '',
                  status: 'done',
                  thumbUrl: data,
                  url: id.identityUrl,
                })
              }
            )

            this.identity[0].identityType = 0
            this.identity[0].identityUrl = id.identityUrl
          }
          if (id.identityType == '1') {
            this.getImgToBase64(
              process.env.VUE_APP_API_BASE_URL +
                '/dfs/download?fileName=' +
                id.identityUrl +
                '&token=' +
                Vue.ls.get(ACCESS_TOKEN),
              function (data) {
                that.fileList2.push({
                  uid: id.identityType,
                  name: '',
                  status: 'done',
                  thumbUrl: data,
                  url: id.identityUrl,
                })
              }
            )
            this.identity[1].identityType = 1
            this.identity[1].identityUrl = id.identityUrl
          }
          if (id.identityType == '2') {
            this.getImgToBase64(
              process.env.VUE_APP_API_BASE_URL +
                '/dfs/download?fileName=' +
                id.identityUrl +
                '&token=' +
                Vue.ls.get(ACCESS_TOKEN),
              function (data) {
                that.fileList3.push({
                  uid: id.identityType,
                  name: '',
                  status: 'done',
                  thumbUrl: data,
                  url: id.identityUrl,
                })
              }
            )
            this.identity[2].identityType = 2
            this.identity[2].identityUrl = id.identityUrl
          }
        }
        res.data.ToNames = res.data.userName
        res.data.Toword = res.data.password
        res.data.ToLogin = res.data.loginName
        this.handleChange9(res.data.receiveOrderList)
        if (res.data.startTime == null && res.data.endTime == null) {
          this.$nextTick(() => {
            this.form.setFieldsValue(
              pick(
                res.data,
                'ToNames',
                'phone',
                'ToLogin',
                'Toword',
                'sex',
                'isTop',
                'receiveOrderList',
                'maxReceiveOrder',
                'installType',
                'masterLevel',
                'settleType',
                'settleTime',
                'bankUserName',
                'bankName',
                'idCard',
                'bankNum',
                'province',
                'city',
                'area',
                'detailedAddress',
                'remark',
                'bigRemark'
              )
            )
          })
        } else {
          res.data.StartTime = [moment(res.data.startTime), moment(res.data.endTime)]
          this.$nextTick(() => {
            this.form.setFieldsValue(
              pick(
                res.data,
                'ToNames',
                'phone',
                'ToLogin',
                'Toword',
                'sex',
                'isTop',
                'receiveOrderList',
                'maxReceiveOrder',
                'installType',
                'masterLevel',
                'settleType',
                'settleTime',
                'bankUserName',
                'bankName',
                'idCard',
                'bankNum',
                'province',
                'city',
                'area',
                'detailedAddress',
                'remark',
                'StartTime',
                'bigRemark'
              )
            )
          })
        }
        this.tabeldata = []
        infoSelectOrder({
          installType: res.data.installType[res.data.installType.length - 1].installType,
          memberId: this.id,
        }).then((res) => {
          this.tabeldata.push(res.data)
        })
        that.haveProvince3(res.data.province)
        that.haveProvince4(res.data.city)
        this.queryParam.abilityScore = res.data.abilityScore
        this.setData.push({
          receiveOrder: res.data.receiveOrder,
          notSaleOrder: res.data.notSaleOrder,
          complaintRateRecent: res.data.complaintRateRecent,
        })
        this.EchartsData = res.data.installType
        let strArr = []
        for (let m = 0; m < this.EchartsData.length; m++) {
          if (this.EchartsData[m].installType == this.addd[0]) {
            strArr = this.EchartsData[m]
          }
        }
        this.$nextTick(() => {
          this.initCharts(strArr)
        })
      })
    },
    //团员提交
    handleSubmit(e) {
      e.preventDefault()
      this.addd = []
      let tempInstalTypes = []
      let that = this
      this.form.validateFields((err, formValues) => {
        let values = _.cloneDeep(formValues)
        values.password = values.Toword
        values.userName = values.ToNames
        values.loginName = values.ToLogin
        delete values.ToLogin
        delete values.ToNames
        delete values.Toword
        if (!err) {
          for (let installTypeIndex in formValues['installType']['installType']) {
            let installType = formValues['installType']['installType'][installTypeIndex]

            for (let val in formValues) {
              const index = val.indexOf('$' + installType)
              if (index !== -1) {
                const tempValName = val.substr(0, index)
                let obj = {}
                obj['installType'] = installType
                obj['installLabelList'] = formValues[val]

                tempInstalTypes.push(obj)
                //values['installType']['installType'][installTypeIndex][tempValName] = values[val]
                delete values[val]
              }
            }
          }
          values.installTypeParam = tempInstalTypes
          // console.log(values)
          delete values.installType
          let arr = []
          for (let i = 0; i < values.receiveOrderList.length; i++) {
            arr.push({
              receiveType: values.receiveOrderList[i],
            })
          }
          values.receiveOrderList = arr
          values.teamId = that.id
          values.identityList = []
          for (let i = 0; i < that.identity.length; i++) {
            if (that.identity[i].identityUrl != undefined && that.identity[i].identityUrl != '') {
              values.identityList.push(that.identity[i])
            }
          }
          values.startTime = this.startTime
          values.endTime = this.endTime
          delete values.StartTime
          if (that.code == 2) {
            foInsert(values).then((res) => {
              //新增团员
              if (res.code === 0) {
                if (res.data == '电话号码和用户名重复') {
                  this.$message.success('电话号码和用户名重复')
                } else {
                  this.$message.success('新增成功')
                  this.$emit('ok')
                  this.visible = false
                }
                this.fileList1 = []
                this.fileList2 = []
                this.fileList3 = []
              } else {
                this.$message.error(res.msg || '添加失败')
              }
            })
          } else {
            values.userId = that.userId
            values.memberId = that.id
            infoInsert(values).then((res) => {
              //修改团员
              if (res.code === 0) {
                this.$message.success('编辑成功')
                this.$emit('ok')
                that.visible = false
                this.fileList1 = []
                this.fileList2 = []
                this.fileList3 = []
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        }
      })
    },
    //服务类别change
    handleCheck11(values) {
      this.installTabs = []
      let that = this
      let arr = this.restaurantTypes1
      for (var j = 0; j < values.length; j++) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].code == values[j]) {
            let isList = {}
            isList.code = arr[i].code
            isList.label = arr[i].label
            this.installTabs.push(isList)
          }
        }
      }
      this.$nextTick(() => {
        if (this.installTabs.length > 0) {
          this.$refs['tabPane'].activeKey = this.installTabs[this.installTabs.length - 1].code
        }
      })
    },
    initCharts(data) {
      this.form.setFieldsValue({
        abilityScore: data.masterAbilityList[0].abilityScore,
      })
      console.log(data, 'initCharts')
      let that = this
      let myChart = this.$echarts.init(this.$refs.chart)
      let dateArr = []
      let NameArr = []
      for (var k = 1; k < data.masterAbilityList.length; k++) {
        dateArr.push(data.masterAbilityList[k].abilityScore)
        NameArr.push({
          value: data.masterAbilityList[k].abilityScore, //能力得分
          abilityName: data.masterAbilityList[k].abilityName, //能力名称
          firstFicScore: data.masterAbilityList[k].firstFicScore, //虚拟得分1
          firstFicTransparency: data.masterAbilityList[k].firstFicTransparency, //虚拟得分透明度1
          secondFicTransparency: data.masterAbilityList[k].secondFicTransparency, //虚拟得分透明度2
          secondFicScore: data.masterAbilityList[k].secondFicScore, //虚拟得分2
        })
      }
      let StrinstallType
      if (data.installType == 'SMART_LOCK') {
        StrinstallType = '智能锁'
      } else if (data.installType == 'LAMP') {
        StrinstallType = '灯具'
      } else if (data.installType == 'SOUND') {
        StrinstallType = '音响'
      } else if (data.installType == 'CURTAIN') {
        StrinstallType = '窗帘'
      }
      // let SeriesArr=[]
      // for(var i=0;i<data.length;i++){
      //   NameArr.push({
      //     name:data[i].installType,
      //     value:[]
      //   })
      // for(var k=1;k<data[i].masterAbilityList.length;k++){
      //   dateArr.push({
      //     name:data[i].installType,//能力名称
      //     value:data[i].masterAbilityList[k].abilityScore,//能力得分
      //     abilityName:data[i].masterAbilityList[k].abilityName,//能力名称
      //     firstFicScore:data[i].masterAbilityList[k].firstFicScore,//虚拟得分1
      //     firstFicTransparency:data[i].masterAbilityList[k].firstFicTransparency,//虚拟得分透明度1
      //     secondFicTransparency:data[i].masterAbilityList[k].secondFicTransparency,//虚拟得分透明度2
      //     secondFicScore:data[i].masterAbilityList[k].secondFicScore,//虚拟得分2
      //   })
      // }
      // }
      // 绘制图表
      myChart.setOption({
        title: {
          text: '服务能力',
        },
        radar: {
          indicator: [
            { name: '安装难度', max: 100 },
            { name: '时效要求', max: 100 },
            { name: '配合度', max: 100 },
            { name: '服务规范', max: 100 },
            { name: '安装规范', max: 100 },
          ],
          triggerEvent: true,
        },
        series: [
          {
            name: '服务能力',
            type: 'radar',
            data: [
              {
                value: dateArr,
                name: StrinstallType,
              },
            ],
          },
        ],
      })
      var alert = document.getElementById('alerts')
      //鼠标事件
      myChart.off('mouseover')
      // alert.style.display = "block"
      myChart.on('mouseover', function (params) {
        // console.log(StrinstallType)
        // console.log(NameArr,'循环数据',params)
        for (let i = 0; i < NameArr.length; i++) {
          if (NameArr[i].abilityName == params.name) {
            console.log('jinru')
            that.$nextTick(() => {
              that.ScoreArr = NameArr[i]
              that.ScoreArr.installType = StrinstallType
            })
          }
        }
        alert.style.left = params.event.offsetX + 20 + 'px'
        alert.style.top = params.event.offsetY + 10 + 'px'
        if (params.event.offsetX > 300) {
          alert.style.left = '300px'
        }
        if (params.event.offsetY > 300) {
          alert.style.top = '300px'
        }
        if (params.event.offsetY > 300 && params.event.offsetX > 300) {
          alert.style.left = '200px'
          alert.style.top = '100px'
        }
        alert.style.display = 'block'
      })
      myChart.on('mouseout', function (params) {
        alert.style.display = 'none'
      })
    },
  },
}
</script>

<style scoped>
#alerts {
  font-size: 14px;
  position: absolute;
  top: 0;
  left: 0;
  display: none;
}
.ant-row {
  margin-top: 10px;
}
/deep/ .redItem .ant-form-item-label label {
  color: red;
}
.redItem .ant-checkbox-wrapper {
  color: red;
}
.disEvents {
  pointer-events: none;
}
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  padding: 4px 16px;
}
</style>
